import { render, staticRenderFns } from "./Multiselect_bank.vue?vue&type=template&id=5442244a"
import script from "./Multiselect_bank.vue?vue&type=script&lang=js"
export * from "./Multiselect_bank.vue?vue&type=script&lang=js"
import style0 from "./Multiselect_bank.vue?vue&type=style&index=0&id=5442244a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports